export const environment = {
  production: false,
  consoleLogDisabled: false,
  siteName: 'ITEM360',
  label: 'environment.uat',
  apiMock: false,
  apiEndpoint: '/proxy/item360/api/v1/item360',
  adCreateEndpoint: '/proxy/ad/api/v1/ad',
  accountApiEndpoint: '/proxy/account/api/v1',
  mailApiEndpoint: '/proxy/mail/api/v1/mail',
  templateApiEndpoint: '/proxy/template/api/v1/template',
  commonApiEndpoint: '/proxy/common/api/v1/common',
  clientId: 'ebeb07ee-fb80-42d7-9833-72ec14b925fc',
  authority:
    'https://login.microsoftonline.com/de047c79-d4d9-4af3-91de-bc44b0581490',
  redirectUrl: 'https://item360-uat.ibpaas.com',
  apimKey: 'e463917644054f3995fc73b817533e59',
  bpaasStoreUrl:
    'https://itu7-apim.azure-api.net/uat-store-api/v1/service/v1/auth/verifyAccessToken',
  storeLoginClientId: 'f03473ec-b675-4343-ae75-f6bb4e74ef9c',
  storeLoginClientSecret: 'hygz+ZOliB8uRzr0bfh5wnC3sSw5Wckq45Yb3oYjcJE',
  sofLicenseEndPoint: 'https://itu7-apim.azure-api.net/uat-sofcheck-api/v1/license-control/service/v1',
  sofLicenseApimKey: 'a6adb39cb25e4975ad7fbc0a447afc15',
};
